import { Icon, Typography11 } from "@slid/slid-ips";
import { Typography14 } from "@slid/slid-ips";
import { Typography20 } from "@slid/slid-ips";
import React from "react";
import styled from "styled-components";
import useNoteMateStore from "store/useNoteMateStore";
import { Message } from "ai/react";
import { trackEvent } from "utils/eventTracking";
import { getEventLocationMode } from "utils/utils";
import { useTranslation } from "react-i18next";
import { eventTypes } from "types/eventTracking";

const ChatHeader = ({
  messages,
  handleClearChat,
  isDarkTheme,
  isDesktopVideonote = false,
}: {
  messages: Message[];
  handleClearChat: () => void;
  isDarkTheme: boolean;
  isDesktopVideonote?: boolean;
}) => {
  const { closeNoteMate } = useNoteMateStore();
  const { t } = useTranslation("NoteMate");

  const handleOpenNewChat = () => {
    trackEvent({
      eventType: eventTypes.click.NEW_CHAT_IN_NOTE_MATE_CHAT,
      eventProperties: {
        from: getEventLocationMode(),
      },
    });
    handleClearChat();
  };

  const handleCloseChat = () => {
    trackEvent({
      eventType: eventTypes.click.CLOSE_NOTE_MATE_CHAT,
      eventProperties: {
        from: getEventLocationMode(),
      },
    });
    closeNoteMate();
  };

  if (isDesktopVideonote) {
    return (
      <PopupChatHeaderContainer isNewChat={messages.length === 0}>
        <NewChatButton onClick={handleOpenNewChat}>
          <Typography11 weight={700} color="--gray6" text={t("NewChatButton")} />
        </NewChatButton>
        <PopupCloseChatButton>
          <Icon icon="x24" width={20} height={20} color={"var(--gray9)"} onClick={handleCloseChat} style={{ cursor: "pointer" }} />
        </PopupCloseChatButton>
      </PopupChatHeaderContainer>
    );
  }
  return (
    <ChatHeaderContainer isNewChat={messages.length === 0}>
      {messages.length > 0 && (
        <TitleContainer>
          <Typography20 weight={700} color={isDarkTheme ? "--gray2" : "--gray16"} text={t("NoteMate")} />
          <NewChatButton onClick={handleOpenNewChat}>
            <Typography14 weight={700} color="--gray6" text={t("NewChatButton")} />
          </NewChatButton>
        </TitleContainer>
      )}
      <CloseChatButton>
        <Icon icon="x24" color={isDarkTheme ? "white" : "var(--gray9)"} onClick={handleCloseChat} style={{ cursor: "pointer" }} />
      </CloseChatButton>
    </ChatHeaderContainer>
  );
};
export default ChatHeader;

const ChatHeaderContainer = styled.div<{ isNewChat: boolean }>`
  width: 100%;
  padding: 16px 20px;
  display: flex;
  align-items: center;
  justify-content: ${({ isNewChat }) => (isNewChat ? "flex-end" : "space-between")};
  gap: 8px;
`;

const PopupChatHeaderContainer = styled(ChatHeaderContainer)`
  border-radius: 16px 16px 0px 0px;
  padding: 12px 12px 8px 12px;
  gap: 0px;
  background-color: var(--white);
  justify-content: flex-end;
`;

const TitleContainer = styled.div`
  width: calc(100% - 24px);
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const NewChatButton = styled.div`
  cursor: pointer;
  padding: 0px 6px;
`;

const CloseChatButton = styled.div`
  height: 28px;
  display: flex;
  justify-content: center;
  cursor: pointer;
`;

const PopupCloseChatButton = styled(CloseChatButton)`
  width: 20px;
  height: 20px;
`;
